export function localDateString(ISODate){

    if(!ISODate) return null;
    if(isNaN(new Date(ISODate))) return ISODate;

    const date = new Date(ISODate);

    const [yy,mm,dd] = [date.getFullYear(), date.getMonth() + 1, date.getDate()];

    return `${dd < 10 ? '0'+ dd : dd}.${mm < 10 ? '0'+mm : mm}.${yy}`;
} 